import React from 'react';
import Link from '@material-ui/core/Link';

const ExternalLink = (props) => <Link {...props} />;

export default ExternalLink;
